import { useState, useEffect, useMemo } from "react";
import { supa } from "../components/firebase";
import { Plus, Minus, PageEdit, ArrowUp, ArrowDown, Calendar, Wallet, User, CheckCircle } from 'iconoir-react'
import { useParams, useNavigate } from "react-router-dom";
import ModalConsulenza from "../components/modalConsulenza";
import ModalLezione from "../components/modalLezione";
import ModalInfoPacchetto from "../components/modalInfoPacchetto";
import ActivityIndicator from "../components/activityIndicator";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Line, Bar, Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);

function ProfiloUtente() {
    const navigate = useNavigate()
    const { id } = useParams();
    const [utente, setUtente] = useState({})
    const [quota, setQuota] = useState(null)

    const [modalConsulenza, setModalConsulenza] = useState(false)

    const [nome, setNome] = useState("")
    const [cognome, setCognome] = useState("")
    const [birth, setBirth] = useState(new Date())
    const [credito, setCredito] = useState(0)


    async function getUtente() {
        const { data, error } = await supa
            .from('utenti')
            .select('*')
            .eq('id', id)
        if (error) console.log("---", error)
        setUtente(data[0])
        setNome(data[0].nome)
        setCognome(data[0].cognome)
        setBirth(data[0].birth)
        setCredito(data[0].credito)
        setQuota(data[0]?.quota)
    }

    const [lezioni, setLezioni] = useState([])
    const [pacchettiAcquistati, setPacchettiAcquistati] = useState([])
    const [versamenti, setVersamenti] = useState([])

    const [lezioniEffettuate, setLezioniEffettuate] = useState([])

    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedPacchettoPersonal, setSelectedPacchettoPersonal] = useState(null)
    const [modalLezione, setModalLezione] = useState(false)
    const [modalInfoPacchetto, setModalInfoPacchetto] = useState(false)

    const openModal = (users, pacchettoPersonal) => {
        setSelectedUser(users)
        setSelectedPacchettoPersonal(pacchettoPersonal)
        setModalLezione(true)
    }

    const openModalInfoPacchetto = (user, pacchetto) => {
        setSelectedUser(user)
        setSelectedPacchettoPersonal(pacchetto)
        setModalInfoPacchetto(true)
    }



    async function getLezioni() {
        const { data, error } = await supa
            .from('lezioni')
            .select('*,utenti(*),personalTrainer(*),pacchettiAcquistati(*,pacchetti(*))')
            .eq('id_utente', utente.id)
        if (error) console.log("---", error)
        data?.sort((a, b) => new Date(a.data) - new Date(b.data))
        setLezioni(data)
    }

    async function getPacchettiAcquistati() {
        const { data, error } = await supa
            .from('pacchettiAcquistati')
            .select('*,pacchetti(*)')
            .eq('id_utente', utente.id)
        if (error) console.log("---", error)
        data?.sort((a, b) => new Date(a.inizio) - new Date(b.inizio))
        setPacchettiAcquistati(data)

    }

    async function patchUtente() {
        const { data, error } = await supa
            .from('utenti')
            .update({ "nome": nome, "cognome": cognome, "birth": birth, "credito": credito, "quota": quota })
            .eq('id', utente.id)
        if (error) console.log(error)
        navigate(-1)
    }

    async function alertPatch() {
        if (window.confirm(`Sei sicuro di voler salvare le modifiche?`)) {
            checkQuota()
        }
    }

    async function checkQuota() {
        if (quota != utente?.quota) {
            if (window.confirm(`Hai modifcato la data di scadenza della quota, vuoi aggiungere anche un versamento per la quota?`)) {
                addVersamento()
            }
            else {patchUtente()}
           

        } else {
            patchUtente()
        }
    }

    async function addVersamento() {
        try{
        const { data, error } = await supa
            .from('pacchettiAcquistati')
            .insert({ "id_utente": utente?.id, "id_pacchetto": 18, "inizio": new Date(), "fine": new Date(), "totale": 40, "acconto": 40, "note": "Versamento automatico per modifica scadenza quota", "tipo": 2, completato: true })
            .select()
        if (error) console.log(",.,",error)
            const { data2, error2 } = await supa
            .from('versamenti')
            .insert({ "id_utente": utente?.id, "id_pacchettiAcquistati": data[0].id, "data": new Date(), "importo": 40 })
        if (error2) console.log(error2)
        patchUtente()
        } catch (error) {
            console.log("-------",error)
        }
    }

    async function getVersamenti() {
        const { data, error } = await supa
            .from('versamenti')
            .select('*,utenti(*),pacchettiAcquistati(*,pacchetti(*))')
            .eq('id_utente', utente.id)
        if (error) console.log("---", error)
        setVersamenti(data)
    }

    useEffect(() => {
        getUtente()

    }, [])

    useEffect(() => {
        utente?.id && getLezioni()
        utente?.id && getPacchettiAcquistati()
        utente?.id && getVersamenti()
    }
        , [utente.id])

    function refreshPage() {
        window.location.reload(false);
    }

    async function patchCheckPacchetto(id) {
        const { data, error } = await supa
            .from('pacchettiAcquistati')
            .update({ "completato": !pacchettiAcquistati.find((item) => item.id === id).completato })
            .eq('id', id)
        if (error) console.log(error);
        refreshPage()
    }

    function alertCheck(id) {
        if (window.confirm(`Sei sicuro di voler segnare come ${!pacchettiAcquistati.find((item) => item.id === id).completato ? "completato" : "non completato"}?`)) {
            patchCheckPacchetto(id)
        }
    }

    function alertDelete() {
        if (window.confirm(`Sei sicuro di voler eliminare il profilo?, \nATTENZIONE: questa azione è irreversibile`)) {
            deleteUtente()
        }
    }

    async function deleteUtente() {
        const { data, error } = await supa
            .from('utenti')
            .delete()
            .eq('id', utente.id)
        if (error) { alert("Errore durante l'eliminazione del profilo \nProbabilmente ha lezioni/pacchetti o versamenti collegati \nContattare GioPz se hai bisogno di assistenza") }
        else {
            navigate(-1)
        }
    }

    // Statistiche utente
    const statistiche = useMemo(() => {
        if (!lezioni.length || !pacchettiAcquistati.length) return null;

        // 1. Frequenza media lezioni/settimana
        const primaLezione = new Date(lezioni[0]?.data);
        const ultimaLezione = new Date(lezioni[lezioni.length - 1]?.data);
        const giorniAttivita = Math.max(1, Math.ceil((ultimaLezione - primaLezione) / (1000 * 60 * 60 * 24)));
        const settimaneAttivita = giorniAttivita / 7;
        const mediaLezioniSettimana = lezioni.length / settimaneAttivita;

        // 2. Andamento mensile (ultimi 6 mesi)
        const ultimi6Mesi = [];
        for (let i = 5; i >= 0; i--) {
            const data = new Date();
            data.setMonth(data.getMonth() - i);
            ultimi6Mesi.push({
                mese: data.toLocaleDateString('it-IT', { month: 'short', year: 'numeric' }),
                lezioni: lezioni.filter(l => {
                    const dataLezione = new Date(l.data);
                    return dataLezione.getMonth() === data.getMonth() && dataLezione.getFullYear() === data.getFullYear();
                }).length
            });
        }

        // 3. Ricavi generati
        const totaleVersamenti = versamenti.reduce((acc, v) => acc + (v.importo || 0), 0);
        const totalePacchetti = pacchettiAcquistati.reduce((acc, p) => acc + (p.totale || 0), 0);

        // 4. Distribuzione Personal Trainer
        const lezioniPerPT = lezioni.reduce((acc, l) => {
            const ptNome = `${l.personalTrainer?.nome} ${l.personalTrainer?.cognome}`;
            acc[ptNome] = (acc[ptNome] || 0) + 1;
            return acc;
        }, {});

        // 5. Distribuzione tipo lezioni
        const lezioniPerTipo = lezioni.reduce((acc, l) => {
            const tipo = l.pacchettiAcquistati?.tipo == 0 ? 'Personal' : 'Pilates';
            acc[tipo] = (acc[tipo] || 0) + 1;
            return acc;
        }, {});

        // 6. Tasso di completamento pacchetti
        const pacchettiCompletati = pacchettiAcquistati.filter(p => p.completato).length;
        const tassoCompletamento = (pacchettiCompletati / pacchettiAcquistati.length) * 100;

        // 7. Media lezioni per pacchetto (solo pacchetti con lezioni)
        const pacchettiConLezioni = pacchettiAcquistati.filter(p => p.tipo != 2); // escludi consulenze
        const mediaLezioniPerPacchetto = lezioni.length / (pacchettiConLezioni.length || 1);

        // 8. Andamento frequenza settimanale (tutte le settimane dall'inizio fino ad ora)
        const primaLezioneData = new Date(lezioni[0]?.data);
        const oggi = new Date();
        const settimaneAttivitaTotali = Math.ceil((oggi - primaLezioneData) / (1000 * 60 * 60 * 24 * 7));
        const numeroSettimaneGrafico = Math.min(52, settimaneAttivitaTotali); // Max 52 settimane (1 anno)
        
        const tutteSettimane = [];
        const tutteSettimanePersonal = [];
        const tutteSettimanePilates = [];
        
        for (let i = numeroSettimaneGrafico - 1; i >= 0; i--) {
            const inizioSettimana = new Date();
            inizioSettimana.setDate(inizioSettimana.getDate() - (i * 7));
            const fineSettimana = new Date(inizioSettimana);
            fineSettimana.setDate(fineSettimana.getDate() + 7);
            
            const lezioniSettimana = lezioni.filter(l => {
                const dataLezione = new Date(l.data);
                return dataLezione >= inizioSettimana && dataLezione < fineSettimana;
            });

            const lezioniPersonal = lezioniSettimana.filter(l => l.pacchettiAcquistati?.tipo == 0).length;
            const lezioniPilates = lezioniSettimana.filter(l => l.pacchettiAcquistati?.tipo == 1).length;
            
            tutteSettimane.push({
                settimana: numeroSettimaneGrafico > 12 ? inizioSettimana.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' }) : `Sett. ${numeroSettimaneGrafico-i}`,
                lezioni: lezioniSettimana.length,
                personal: lezioniPersonal,
                pilates: lezioniPilates
            });
            tutteSettimanePersonal.push(lezioniPersonal);
            tutteSettimanePilates.push(lezioniPilates);
        }

        // 9. Ultima lezione e giorni di assenza
        const ultimaLezioneData = new Date(lezioni[lezioni.length - 1]?.data);
        const giorniDallUltimaLezione = Math.floor((oggi - ultimaLezioneData) / (1000 * 60 * 60 * 24));
        const inattivo = giorniDallUltimaLezione > 21; // più di 3 settimane
        const moltoinattivo = giorniDallUltimaLezione > 60; // più di 2 mesi

        // 9. Trend frequenza (confronto ultimi 30 giorni vs 30 giorni precedenti)
        const trentaGiorniFa = new Date(oggi);
        trentaGiorniFa.setDate(trentaGiorniFa.getDate() - 30);
        const sessantaGiorniFa = new Date(oggi);
        sessantaGiorniFa.setDate(sessantaGiorniFa.getDate() - 60);
        
        const lezioniUltimi30Giorni = lezioni.filter(l => new Date(l.data) >= trentaGiorniFa).length;
        const lezioni30GiorniPrecedenti = lezioni.filter(l => {
            const d = new Date(l.data);
            return d >= sessantaGiorniFa && d < trentaGiorniFa;
        }).length;
        
        const trendPercentuale = lezioni30GiorniPrecedenti > 0 
            ? ((lezioniUltimi30Giorni - lezioni30GiorniPrecedenti) / lezioni30GiorniPrecedenti) * 100 
            : (lezioniUltimi30Giorni > 0 ? 100 : (giorniDallUltimaLezione > 30 ? -100 : 0));

        // 10. Analisi costanza per tipo (prima metà vs seconda metà del periodo)
        const metaIndice = Math.floor(tutteSettimane.length / 2);
        const trendPersonal = tutteSettimanePersonal.slice(metaIndice).reduce((a,b) => a+b, 0) - tutteSettimanePersonal.slice(0, metaIndice).reduce((a,b) => a+b, 0);
        const trendPilates = tutteSettimanePilates.slice(metaIndice).reduce((a,b) => a+b, 0) - tutteSettimanePilates.slice(0, metaIndice).reduce((a,b) => a+b, 0);
        
        // 11. Alert cali (confronto metà periodo)
        const mediaPrimaMetà = tutteSettimane.slice(0, metaIndice).reduce((a,b) => a + b.lezioni, 0) / metaIndice;
        const mediaSecondaMetà = tutteSettimane.slice(metaIndice).reduce((a,b) => a + b.lezioni, 0) / (tutteSettimane.length - metaIndice);
        const caloriaFrequenza = mediaSecondaMetà < mediaPrimaMetà * 0.7 || inattivo; // calo > 30% o inattivo

        // 12. Acquisti e versamenti mensili (ultimi 6 mesi)
        const acquistiVersamentiMensili = [];
        for (let i = 5; i >= 0; i--) {
            const data = new Date();
            data.setMonth(data.getMonth() - i);
            
            // Pacchetti acquistati in questo mese
            const pacchettiDelMese = pacchettiAcquistati.filter(p => {
                const dataInizio = new Date(p.inizio);
                return dataInizio.getMonth() === data.getMonth() && 
                       dataInizio.getFullYear() === data.getFullYear();
            });
            
            // Versamenti fatti in questo mese
            const versamentiDelMese = versamenti.filter(v => {
                const dataVersamento = new Date(v.data);
                return dataVersamento.getMonth() === data.getMonth() && 
                       dataVersamento.getFullYear() === data.getFullYear();
            });
            
            const totaleAcquistato = pacchettiDelMese.reduce((acc, p) => acc + (p.totale || 0), 0);
            const totaleVersato = versamentiDelMese.reduce((acc, v) => acc + (v.importo || 0), 0);
            
            acquistiVersamentiMensili.push({
                mese: data.toLocaleDateString('it-IT', { month: 'short', year: 'numeric' }),
                acquistato: totaleAcquistato,
                versato: totaleVersato,
                nPacchetti: pacchettiDelMese.length,
                nVersamenti: versamentiDelMese.length
            });
        }

        // Saldo corrente
        const saldoCorrente = totalePacchetti - totaleVersamenti;

        return {
            mediaLezioniSettimana,
            ultimi6Mesi,
            totaleVersamenti,
            totalePacchetti,
            lezioniPerPT,
            lezioniPerTipo,
            tassoCompletamento,
            mediaLezioniPerPacchetto,
            tutteSettimane,
            tutteSettimanePersonal,
            tutteSettimanePilates,
            trendPercentuale,
            lezioniUltimi30Giorni,
            lezioni30GiorniPrecedenti,
            giorniAttivita,
            trendPersonal,
            trendPilates,
            caloriaFrequenza,
            giorniDallUltimaLezione,
            ultimaLezioneData,
            inattivo,
            moltoinattivo,
            numeroSettimaneGrafico,
            acquistiVersamentiMensili,
            saldoCorrente
        };
    }, [lezioni, pacchettiAcquistati, versamenti]);




    return (
        <div className="min-h-screen bg-gradient-to-br from-zinc-50 to-zinc-100 overflow-scroll noBar">
            {modalConsulenza && utente?.id && <ModalConsulenza visible={modalConsulenza} setVisible={setModalConsulenza} aggiorna={refreshPage} utente={utente} />}
            {modalLezione && <ModalLezione visible={modalLezione} setVisible={setModalLezione} aggiorna={refreshPage} utente={utente} pacchetto={selectedPacchettoPersonal} />}
            {modalInfoPacchetto && <ModalInfoPacchetto visible={modalInfoPacchetto} setVisible={setModalInfoPacchetto} aggiorna={refreshPage} utente={utente} pacchetto={selectedPacchettoPersonal} />}

            {!utente?.id ? (
                <div className="flex items-center justify-center min-h-screen">
                    <ActivityIndicator />
                </div>
            ) : (
                <div className="w-full px-4 sm:px-6 lg:px-8 py-8 space-y-6">
                    {/* Header Section */}
                    <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 p-6">
                        <div className="flex items-center justify-between mb-6">
                            <div>
                                <h1 className="text-3xl font-bold text-zinc-900">Profilo Utente</h1>
                                <p className="mt-1 text-sm text-zinc-600">{nome} {cognome}</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <button 
                                    onClick={() => setModalConsulenza(true)} 
                                    className="inline-flex items-center gap-2 px-4 py-2.5 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-semibold rounded-xl text-sm shadow-sm hover:shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                >
                                    <Plus className="w-4 h-4" />
                                    <span>Aggiungi consulenza</span>
                                </button>
                                <button 
                                    onClick={() => alertDelete()} 
                                    className="inline-flex items-center gap-2 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-xl text-sm shadow-sm hover:shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500"
                                >
                                    Elimina profilo
                                </button>
                            </div>
                        </div>
                        
                        {/* Quota Associativa - Integrated in header */}
                        <div className="pt-4 border-t border-zinc-200">
                            <div className="flex items-center gap-4">
                                <label className="text-sm font-medium text-zinc-700 min-w-[140px]">Quota Associativa:</label>
                                <input 
                                    type="date" 
                                    onChange={(e) => setQuota(e.target.value)} 
                                    value={quota} 
                                    className={`${
                                        (quota != null && new Date(quota) > new Date()) 
                                            ? "bg-green-50 border-green-300 text-green-900" 
                                            : "bg-red-50 border-red-300 text-red-900"
                                    } border text-sm rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 w-48 p-2.5 transition-all`}
                                />
                                <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-semibold ${
                                    (quota != null && new Date(quota) > new Date())
                                        ? "bg-green-100 text-green-700"
                                        : "bg-red-100 text-red-700"
                                }`}>
                                    {(quota != null && new Date(quota) > new Date()) ? "● Attiva" : "● Scaduta"}
                                </span>
                            </div>
                        </div>
                    </div>
                    {/* Personal Info Form */}
                    <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 p-6">
                        <h2 className="text-xl font-semibold text-zinc-900 mb-4">Informazioni Personali</h2>
                        <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
                            <div>
                                <label className="block mb-2 text-sm font-medium text-zinc-700">Nome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setNome(e.target.value.toLocaleUpperCase())} 
                                    value={nome} 
                                    className="bg-white border border-zinc-300 text-zinc-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 block w-full p-2.5 transition-all" 
                                    placeholder="Inserisci nome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-zinc-700">Cognome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setCognome(e.target.value.toLocaleUpperCase())} 
                                    value={cognome} 
                                    className="bg-white border border-zinc-300 text-zinc-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 block w-full p-2.5 transition-all" 
                                    placeholder="Inserisci cognome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-zinc-700">Data di nascita</label>
                                <input 
                                    type="date" 
                                    value={birth} 
                                    onChange={(e) => setBirth(e.target.value)} 
                                    className="bg-white border border-zinc-300 text-zinc-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 block w-full p-2.5 transition-all"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-zinc-700">Credito</label>
                                <input 
                                    type="number" 
                                    onChange={(e) => setCredito(e.target.value)} 
                                    value={credito} 
                                    className="bg-white border border-zinc-300 text-zinc-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 block w-full p-2.5 transition-all" 
                                    placeholder="Credito utente"
                                />
                            </div>
                        </div>
                    </div>
                    {/* Acquisti Section */}
                    <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden">
                        <div className="px-6 py-5 border-b border-zinc-200">
                            <div className="flex items-center justify-between">
                                <h2 className="text-xl font-semibold text-zinc-900">Acquisti effettuati</h2>
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-700">
                                    {pacchettiAcquistati?.length}
                                </span>
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            <div className="max-h-96 overflow-y-auto">
                                <table className="w-full">
                                    <thead className="bg-zinc-50 border-b border-zinc-200 sticky top-0 z-10">
                                        <tr>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Pacchetto</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Inizio</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Fine</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Totale</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Acconto</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Rimanente</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Sed. pacchetto</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Sed. effettuate</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Completato</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-zinc-100">
                                        {pacchettiAcquistati?.map((item, index) => (
                                            <tr key={index} className="hover:bg-zinc-50 transition-colors">
                                                <td className="px-6 py-4 text-sm font-medium text-zinc-900">{item?.pacchetti?.nome}, {item?.totale} €</td>
                                                <td className="px-6 py-4 text-sm text-zinc-600">{item?.inizio ? new Date(item?.inizio).toLocaleDateString('it-IT') : "-"}</td>
                                                <td className="px-6 py-4 text-sm text-zinc-600">{item?.fine ? new Date(item?.fine).toLocaleDateString('it-IT') : "-"}</td>
                                                <td className="px-6 py-4 text-sm font-semibold text-zinc-900">{item?.totale} €</td>
                                                <td className="px-6 py-4 text-sm text-zinc-600">{item?.acconto} €</td>
                                                <td className="px-6 py-4 text-sm font-semibold text-zinc-900">{item?.totale - item?.acconto} €</td>
                                                <td className="px-6 py-4 text-sm text-zinc-600">{item?.pacchetti?.num_lezioni}</td>
                                                <td className={`px-6 py-4 ${item?.tipo == 2 && "invisible"}`}>
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-sm font-semibold text-zinc-900">{item?.sedute_effettuate}</span>
                                                        <button 
                                                            onClick={() => openModal(item?.utenti, item)} 
                                                            className="p-1.5 bg-yellow-400 hover:bg-yellow-500 rounded-lg transition-colors"
                                                        >
                                                            <Plus className="w-4 h-4 text-zinc-900" />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className={`${item?.tipo == 2 && "invisible"} px-6 py-4`}>
                                                    <input 
                                                        type="checkbox" 
                                                        checked={item?.completato} 
                                                        onChange={() => alertCheck(item.id)} 
                                                        className="w-4 h-4 text-yellow-400 bg-zinc-100 border-zinc-300 rounded focus:ring-yellow-400 focus:ring-2 cursor-pointer"
                                                    />
                                                </td>
                                                <td className="px-6 py-4">
                                                    <button 
                                                        onClick={() => openModalInfoPacchetto(item?.utenti, item)} 
                                                        className="p-2 hover:bg-blue-100 rounded-lg transition-colors"
                                                    >
                                                        <PageEdit className="w-5 h-5 text-blue-600" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* Lezioni e Versamenti Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* Lezioni Section */}
                        <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden">
                            <div className="px-6 py-5 border-b border-zinc-200">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-xl font-semibold text-zinc-900">Lezioni effettuate</h2>
                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-700">
                                        {lezioni?.length}
                                    </span>
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <div className="max-h-80 overflow-y-auto">
                                    <table className="w-full">
                                        <thead className="bg-zinc-50 border-b border-zinc-200 sticky top-0 z-10">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Data</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Personal Trainer</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Pacchetto</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Tipo</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-zinc-100">
                                            {lezioni?.map((item, index) => (
                                                <tr key={index} className="hover:bg-zinc-50 transition-colors">
                                                    <td className="px-6 py-3 text-sm text-zinc-600">{item?.data ? new Date(item?.data).toLocaleDateString('it-IT') : "-"}</td>
                                                    <td className="px-6 py-3 text-sm font-medium text-zinc-900">{item?.personalTrainer?.nome} {item?.personalTrainer?.cognome}</td>
                                                    <td className="px-6 py-3 text-sm text-zinc-600">{item.pacchettiAcquistati?.pacchetti.nome}</td>
                                                    <td className="px-6 py-3">
                                                        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${
                                                            item?.pacchettiAcquistati?.tipo == "0" 
                                                                ? "bg-purple-100 text-purple-700" 
                                                                : "bg-blue-100 text-blue-700"
                                                        }`}>
                                                            {item?.pacchettiAcquistati?.tipo == "0" ? "Personal" : "Pilates"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Versamenti Section */}
                        <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden">
                            <div className="px-6 py-5 border-b border-zinc-200">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-xl font-semibold text-zinc-900">Versamenti effettuati</h2>
                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-orange-100 text-orange-700">
                                        {versamenti?.length}
                                    </span>
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <div className="max-h-80 overflow-y-auto">
                                    <table className="w-full">
                                        <thead className="bg-zinc-50 border-b border-zinc-200 sticky top-0 z-10">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Data</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Pacchetto</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Tipo</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Importo</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-zinc-100">
                                            {versamenti?.map((item, index) => (
                                                <tr key={index} className="hover:bg-zinc-50 transition-colors">
                                                    <td className="px-6 py-3 text-sm text-zinc-600">{item?.data ? new Date(item?.data).toLocaleDateString('it-IT') : "-"}</td>
                                                    <td className="px-6 py-3 text-sm font-medium text-zinc-900">{item.pacchettiAcquistati?.pacchetti.nome}</td>
                                                    <td className="px-6 py-3">
                                                        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${
                                                            item?.pacchettiAcquistati?.tipo == 0 
                                                                ? "bg-purple-100 text-purple-700" 
                                                                : item?.pacchettiAcquistati?.tipo == 1 
                                                                    ? "bg-blue-100 text-blue-700"
                                                                    : "bg-green-100 text-green-700"
                                                        }`}>
                                                            {item?.pacchettiAcquistati?.tipo == 0 ? "Personal" : item?.pacchettiAcquistati?.tipo == 1 ? "Pilates" : "Consulenza"}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-3 text-sm font-semibold text-zinc-900">{item?.importo} €</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Statistiche Utente */}
                    {statistiche && (
                        <div className="space-y-6">
                            {/* Header Statistiche */}
                            <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 p-6">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <h2 className="text-2xl font-bold text-zinc-900">Statistiche e Analisi</h2>
                                        <p className="text-sm text-zinc-600 mt-1">Panoramica completa dell'attività dell'utente</p>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        {statistiche.moltoinattivo && (
                                            <div className="flex items-center gap-2 px-4 py-2 bg-red-100 border border-red-300 rounded-xl">
                                                <ArrowDown className="w-5 h-5 text-red-600" />
                                                <span className="text-sm font-semibold text-red-700">
                                                    ⚠️ Assente da {statistiche.giorniDallUltimaLezione} giorni (ultima: {statistiche.ultimaLezioneData.toLocaleDateString('it-IT')})
                                                </span>
                                            </div>
                                        )}
                                        {!statistiche.moltoinattivo && statistiche.inattivo && (
                                            <div className="flex items-center gap-2 px-4 py-2 bg-orange-100 border border-orange-300 rounded-xl">
                                                <ArrowDown className="w-5 h-5 text-orange-600" />
                                                <span className="text-sm font-semibold text-orange-700">
                                                    Assente da {statistiche.giorniDallUltimaLezione} giorni
                                                </span>
                                            </div>
                                        )}
                                        {!statistiche.inattivo && statistiche.caloriaFrequenza && (
                                            <div className="flex items-center gap-2 px-4 py-2 bg-yellow-100 border border-yellow-300 rounded-xl">
                                                <ArrowDown className="w-5 h-5 text-yellow-600" />
                                                <span className="text-sm font-semibold text-yellow-700">Calo frequenza rilevato</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* KPI Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                {/* Frequenza Media */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-5 hover:shadow-md transition-shadow">
                                    <div className="flex items-center justify-between mb-3">
                                        <Calendar className="w-8 h-8 text-blue-500" />
                                        <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${
                                            statistiche.trendPercentuale >= 0 
                                                ? 'bg-green-100 text-green-700' 
                                                : 'bg-red-100 text-red-700'
                                        }`}>
                                            {statistiche.trendPercentuale >= 0 ? '+' : ''}{statistiche.trendPercentuale.toFixed(1)}%
                                        </span>
                                    </div>
                                    <p className="text-3xl font-bold text-zinc-900">{statistiche.mediaLezioniSettimana.toFixed(1)}</p>
                                    <p className="text-sm text-zinc-600 mt-1">Lezioni/settimana</p>
                                    <p className="text-xs text-zinc-500 mt-2">
                                        {statistiche.lezioniUltimi30Giorni} lezioni ultimi 30gg vs {statistiche.lezioni30GiorniPrecedenti} precedenti
                                    </p>
                                </div>

                                {/* Totale Ricavi */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-5 hover:shadow-md transition-shadow">
                                    <div className="flex items-center justify-between mb-3">
                                        <Wallet className="w-8 h-8 text-green-500" />
                                    </div>
                                    <p className="text-3xl font-bold text-zinc-900">{statistiche.totalePacchetti.toFixed(0)} €</p>
                                    <p className="text-sm text-zinc-600 mt-1">Ricavi Totali</p>
                                    <p className="text-xs text-zinc-500 mt-2">
                                        Versati: {statistiche.totaleVersamenti} € ({((statistiche.totaleVersamenti/statistiche.totalePacchetti)*100).toFixed(0)}%)
                                    </p>
                                </div>

                                {/* Tasso Completamento */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-5 hover:shadow-md transition-shadow">
                                    <div className="flex items-center justify-between mb-3">
                                        <CheckCircle className="w-8 h-8 text-purple-500" />
                                    </div>
                                    <p className="text-3xl font-bold text-zinc-900">{statistiche.tassoCompletamento.toFixed(0)}%</p>
                                    <p className="text-sm text-zinc-600 mt-1">Pacchetti Completati</p>
                                    <p className="text-xs text-zinc-500 mt-2">
                                        {pacchettiAcquistati.filter(p => p.completato).length} su {pacchettiAcquistati.length} pacchetti
                                    </p>
                                </div>

                                {/* Media Lezioni */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-5 hover:shadow-md transition-shadow">
                                    <div className="flex items-center justify-between mb-3">
                                        <User className="w-8 h-8 text-orange-500" />
                                    </div>
                                    <p className="text-3xl font-bold text-zinc-900">{statistiche.mediaLezioniPerPacchetto.toFixed(1)}</p>
                                    <p className="text-sm text-zinc-600 mt-1">Media Lezioni/Pacchetto</p>
                                    <p className="text-xs text-zinc-500 mt-2">
                                        {pacchettiAcquistati.filter(p => p.tipo != 2).length} pacchetti acquistati (escluse consulenze)
                                    </p>
                                </div>
                            </div>

                            {/* Grafici */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                {/* Andamento Settimanale Totale */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">
                                        📈 Andamento Completo ({statistiche.numeroSettimaneGrafico} settimane)
                                    </h3>
                                    <div className="h-64">
                                        <Line
                                            data={{
                                                labels: statistiche.tutteSettimane.map(s => s.settimana),
                                                datasets: [{
                                                    label: 'Lezioni Totali',
                                                    data: statistiche.tutteSettimane.map(s => s.lezioni),
                                                    borderColor: 'rgb(250, 204, 21)',
                                                    backgroundColor: 'rgba(250, 204, 21, 0.1)',
                                                    tension: 0.4,
                                                    fill: true,
                                                    borderWidth: 2
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: { display: true }
                                                },
                                                scales: {
                                                    y: {
                                                        beginAtZero: true,
                                                        ticks: { stepSize: 1 }
                                                    },
                                                    x: {
                                                        ticks: {
                                                            maxRotation: 45,
                                                            minRotation: 45,
                                                            autoSkip: true,
                                                            maxTicksLimit: 12
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="mt-4 p-3 bg-yellow-50 rounded-lg">
                                        <p className="text-sm text-zinc-700">
                                            <span className="font-semibold">Media storica:</span> {statistiche.mediaLezioniSettimana.toFixed(1)} lezioni/settimana
                                            {statistiche.giorniDallUltimaLezione > 0 && (
                                                <> • <span className="font-semibold">Ultima lezione:</span> {statistiche.giorniDallUltimaLezione} giorni fa</>
                                            )}
                                        </p>
                                    </div>
                                </div>

                                {/* Grafico Costanza Personal vs Pilates */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">🎯 Costanza Allenamento per Tipo</h3>
                                    <div className="h-64">
                                        <Line
                                            data={{
                                                labels: statistiche.tutteSettimane.map(s => s.settimana),
                                                datasets: [
                                                    {
                                                        label: 'Personal Training',
                                                        data: statistiche.tutteSettimane.map(s => s.personal),
                                                        borderColor: 'rgb(168, 85, 247)',
                                                        backgroundColor: 'rgba(168, 85, 247, 0.1)',
                                                        tension: 0.4,
                                                        fill: true,
                                                        borderWidth: 2
                                                    },
                                                    {
                                                        label: 'Pilates',
                                                        data: statistiche.tutteSettimane.map(s => s.pilates),
                                                        borderColor: 'rgb(59, 130, 246)',
                                                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                                                        tension: 0.4,
                                                        fill: true,
                                                        borderWidth: 2
                                                    }
                                                ]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: { 
                                                        display: true,
                                                        position: 'top'
                                                    }
                                                },
                                                scales: {
                                                    y: {
                                                        beginAtZero: true,
                                                        ticks: { stepSize: 1 }
                                                    },
                                                    x: {
                                                        ticks: {
                                                            maxRotation: 45,
                                                            minRotation: 45,
                                                            autoSkip: true,
                                                            maxTicksLimit: 12
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="mt-4 grid grid-cols-2 gap-3">
                                        <div className={`p-3 rounded-lg ${statistiche.trendPersonal >= 0 ? 'bg-green-50' : 'bg-red-50'}`}>
                                            <div className="flex items-center gap-2">
                                                {statistiche.trendPersonal >= 0 ? 
                                                    <ArrowUp className="w-4 h-4 text-green-600" /> : 
                                                    <ArrowDown className="w-4 h-4 text-red-600" />
                                                }
                                                <span className={`text-sm font-semibold ${statistiche.trendPersonal >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                                                    Personal: {statistiche.trendPersonal > 0 ? '+' : ''}{statistiche.trendPersonal}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={`p-3 rounded-lg ${statistiche.trendPilates >= 0 ? 'bg-green-50' : 'bg-red-50'}`}>
                                            <div className="flex items-center gap-2">
                                                {statistiche.trendPilates >= 0 ? 
                                                    <ArrowUp className="w-4 h-4 text-green-600" /> : 
                                                    <ArrowDown className="w-4 h-4 text-red-600" />
                                                }
                                                <span className={`text-sm font-semibold ${statistiche.trendPilates >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                                                    Pilates: {statistiche.trendPilates > 0 ? '+' : ''}{statistiche.trendPilates}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Andamento Mensile */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">📅 Andamento Ultimi 6 Mesi</h3>
                                    <div className="h-64">
                                        <Bar
                                            data={{
                                                labels: statistiche.ultimi6Mesi.map(m => m.mese),
                                                datasets: [{
                                                    label: 'Lezioni',
                                                    data: statistiche.ultimi6Mesi.map(m => m.lezioni),
                                                    backgroundColor: 'rgba(59, 130, 246, 0.8)',
                                                    borderRadius: 8
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: { display: false }
                                                },
                                                scales: {
                                                    y: {
                                                        beginAtZero: true,
                                                        ticks: { stepSize: 2 }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Distribuzione Personal Trainer */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">👤 Personal Trainer Preferiti</h3>
                                    <div className="h-64">
                                        <Pie
                                            data={{
                                                labels: Object.keys(statistiche.lezioniPerPT),
                                                datasets: [{
                                                    data: Object.values(statistiche.lezioniPerPT),
                                                    backgroundColor: [
                                                        'rgba(250, 204, 21, 0.8)',
                                                        'rgba(59, 130, 246, 0.8)',
                                                        'rgba(16, 185, 129, 0.8)',
                                                        'rgba(249, 115, 22, 0.8)',
                                                        'rgba(168, 85, 247, 0.8)',
                                                    ],
                                                    borderWidth: 2,
                                                    borderColor: '#fff'
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: {
                                                        position: 'bottom'
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Distribuzione Tipo Lezioni */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">🏋️ Tipo di Allenamento</h3>
                                    <div className="h-64">
                                        <Pie
                                            data={{
                                                labels: Object.keys(statistiche.lezioniPerTipo),
                                                datasets: [{
                                                    data: Object.values(statistiche.lezioniPerTipo),
                                                    backgroundColor: [
                                                        'rgba(168, 85, 247, 0.8)',
                                                        'rgba(59, 130, 246, 0.8)'
                                                    ],
                                                    borderWidth: 2,
                                                    borderColor: '#fff'
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: {
                                                        position: 'bottom'
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Acquisti vs Versamenti Mensili */}
                                <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
                                    <h3 className="text-lg font-semibold text-zinc-900 mb-4">� Andamento Saldo</h3>
                                    <div className="h-64">
                                        <Bar
                                            data={{
                                                labels: statistiche.acquistiVersamentiMensili.map(m => m.mese),
                                                datasets: [
                                                    {
                                                        label: 'Acquistato',
                                                        data: statistiche.acquistiVersamentiMensili.map(m => m.acquistato),
                                                        backgroundColor: 'rgba(239, 68, 68, 0.8)',
                                                        borderRadius: 6
                                                    },
                                                    {
                                                        label: 'Versato',
                                                        data: statistiche.acquistiVersamentiMensili.map(m => m.versato),
                                                        backgroundColor: 'rgba(34, 197, 94, 0.8)',
                                                        borderRadius: 6
                                                    }
                                                ]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: { 
                                                        display: true,
                                                        position: 'top'
                                                    },
                                                    tooltip: {
                                                        callbacks: {
                                                            afterLabel: function(context) {
                                                                const idx = context.dataIndex;
                                                                const item = statistiche.acquistiVersamentiMensili[idx];
                                                                if (context.dataset.label === 'Acquistato') {
                                                                    return `${item.nPacchetti} pacchetti acquistati`;
                                                                } else {
                                                                    return `${item.nVersamenti} versamenti`;
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                scales: {
                                                    y: {
                                                        beginAtZero: true,
                                                        ticks: {
                                                            callback: function(value) {
                                                                return value.toFixed(0) + ' €';
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={`mt-4 p-3 rounded-lg ${statistiche.saldoCorrente > 0 ? 'bg-orange-50' : 'bg-green-50'}`}>
                                        <p className={`text-sm ${statistiche.saldoCorrente > 0 ? 'text-orange-700' : 'text-green-700'}`}>
                                            <span className="font-semibold">Saldo totale:</span> {statistiche.saldoCorrente > 0 ? `Da riscuotere ${statistiche.saldoCorrente.toFixed(2)} €` : 'Tutto pagato! ✅'}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Tabella Dettagli PT */}
                            <div className="bg-white rounded-xl shadow-sm border border-zinc-200 overflow-hidden">
                                <div className="px-6 py-5 border-b border-zinc-200">
                                    <h3 className="text-lg font-semibold text-zinc-900">📊 Dettagli Performance per Personal Trainer</h3>
                                </div>
                                <div className="overflow-x-auto">
                                    <table className="w-full">
                                        <thead className="bg-zinc-50 border-b border-zinc-200">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase">Personal Trainer</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase">Lezioni Totali</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase">Percentuale</th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-zinc-700 uppercase">Ultima Lezione</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-zinc-100">
                                            {Object.entries(statistiche.lezioniPerPT)
                                                .sort(([,a], [,b]) => b - a)
                                                .map(([pt, count], index) => {
                                                    const ultimaLezione = lezioni
                                                        .filter(l => `${l.personalTrainer?.nome} ${l.personalTrainer?.cognome}` === pt)
                                                        .sort((a, b) => new Date(b.data) - new Date(a.data))[0];
                                                    const percentuale = (count / lezioni.length) * 100;
                                                    
                                                    return (
                                                        <tr key={index} className="hover:bg-zinc-50">
                                                            <td className="px-6 py-4 text-sm font-medium text-zinc-900">{pt}</td>
                                                            <td className="px-6 py-4 text-sm text-zinc-600">{count}</td>
                                                            <td className="px-6 py-4">
                                                                <div className="flex items-center gap-2">
                                                                    <div className="flex-1 bg-zinc-200 rounded-full h-2 max-w-[100px]">
                                                                        <div 
                                                                            className="bg-yellow-400 h-2 rounded-full" 
                                                                            style={{ width: `${percentuale}%` }}
                                                                        ></div>
                                                                    </div>
                                                                    <span className="text-sm text-zinc-600">{percentuale.toFixed(1)}%</span>
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 text-sm text-zinc-600">
                                                                {ultimaLezione?.data ? new Date(ultimaLezione.data).toLocaleDateString('it-IT') : '-'}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Insights */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className={`rounded-xl p-6 border ${
                                    statistiche.trendPercentuale >= 10 
                                        ? 'bg-gradient-to-br from-green-50 to-green-100 border-green-200' 
                                        : statistiche.trendPercentuale <= -10
                                            ? 'bg-gradient-to-br from-red-50 to-red-100 border-red-200'
                                            : 'bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200'
                                }`}>
                                    <div className="flex items-center gap-2 mb-2">
                                        {statistiche.trendPercentuale >= 0 ? (
                                            <ArrowUp className={`w-5 h-5 ${statistiche.trendPercentuale >= 10 ? 'text-green-700' : 'text-blue-700'}`} />
                                        ) : (
                                            <ArrowDown className="w-5 h-5 text-red-700" />
                                        )}
                                        <h4 className={`font-semibold ${
                                            statistiche.trendPercentuale >= 10 ? 'text-green-900' : statistiche.trendPercentuale <= -10 ? 'text-red-900' : 'text-blue-900'
                                        }`}>Trend Frequenza</h4>
                                    </div>
                                    <p className={`text-sm ${
                                        statistiche.trendPercentuale >= 10 ? 'text-green-800' : statistiche.trendPercentuale <= -10 ? 'text-red-800' : 'text-blue-800'
                                    }`}>
                                        {statistiche.trendPercentuale > 5 ? (
                                            <>La frequenza è in <span className="font-bold">crescita</span> del {Math.abs(statistiche.trendPercentuale).toFixed(1)}% negli ultimi 30 giorni. Ottimo andamento! 🎉</>
                                        ) : statistiche.trendPercentuale < -5 ? (
                                            <>La frequenza è in <span className="font-bold">calo</span> del {Math.abs(statistiche.trendPercentuale).toFixed(1)}% negli ultimi 30 giorni. Considera un follow-up! ⚠️</>
                                        ) : (
                                            <>La frequenza è <span className="font-bold">stabile</span> ({statistiche.trendPercentuale >= 0 ? '+' : ''}{statistiche.trendPercentuale.toFixed(1)}%) negli ultimi 30 giorni.</>
                                        )}
                                    </p>
                                </div>

                                <div className={`rounded-xl p-6 border ${
                                    statistiche.trendPersonal < 0 
                                        ? 'bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200'
                                        : 'bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200'
                                }`}>
                                    <div className="flex items-center gap-2 mb-2">
                                        {statistiche.trendPersonal < 0 ? (
                                            <ArrowDown className="w-5 h-5 text-orange-700" />
                                        ) : (
                                            <ArrowUp className="w-5 h-5 text-purple-700" />
                                        )}
                                        <h4 className={`font-semibold ${statistiche.trendPersonal < 0 ? 'text-orange-900' : 'text-purple-900'}`}>Personal Training</h4>
                                    </div>
                                    <p className={`text-sm ${statistiche.trendPersonal < 0 ? 'text-orange-800' : 'text-purple-800'}`}>
                                        {statistiche.trendPersonal < 0 ? (
                                            <>Le sessioni Personal sono <span className="font-bold">diminuite</span> di {Math.abs(statistiche.trendPersonal)} nelle ultime 6 settimane. 📉</>
                                        ) : statistiche.trendPersonal > 0 ? (
                                            <>Le sessioni Personal sono <span className="font-bold">aumentate</span> di {statistiche.trendPersonal} nelle ultime 6 settimane. 💪</>
                                        ) : (
                                            <>Le sessioni Personal sono <span className="font-bold">stabili</span> nelle ultime settimane.</>
                                        )}
                                    </p>
                                </div>

                                <div className={`rounded-xl p-6 border ${
                                    statistiche.totaleVersamenti >= statistiche.totalePacchetti
                                        ? 'bg-gradient-to-br from-green-50 to-green-100 border-green-200'
                                        : 'bg-gradient-to-br from-yellow-50 to-yellow-100 border-yellow-200'
                                }`}>
                                    <div className="flex items-center gap-2 mb-2">
                                        <Wallet className={`w-5 h-5 ${statistiche.totaleVersamenti >= statistiche.totalePacchetti ? 'text-green-700' : 'text-yellow-700'}`} />
                                        <h4 className={`font-semibold ${statistiche.totaleVersamenti >= statistiche.totalePacchetti ? 'text-green-900' : 'text-yellow-900'}`}>Situazione Pagamenti</h4>
                                    </div>
                                    <p className={`text-sm ${statistiche.totaleVersamenti >= statistiche.totalePacchetti ? 'text-green-800' : 'text-yellow-800'}`}>
                                        {statistiche.totaleVersamenti >= statistiche.totalePacchetti ? (
                                            <>Tutti i pagamenti sono stati completati! ✅</>
                                        ) : (
                                            <>Saldo pendente: <span className="font-bold">{(statistiche.totalePacchetti - statistiche.totaleVersamenti).toFixed(0)} €</span> ({((1 - statistiche.totaleVersamenti/statistiche.totalePacchetti)*100).toFixed(0)}% da riscuotere)</>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Save Button */}
                    {(nome != utente.nome || cognome != utente?.cognome || birth != utente?.birth || credito != utente?.credito || quota != utente?.quota) && (
                        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                            <button 
                                onClick={() => alertPatch()} 
                                className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-bold rounded-xl text-base shadow-lg hover:shadow-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                            >
                                Salva Modifiche
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default ProfiloUtente;
